import { isValid } from "date-fns";
import React from "react";

import { TSurveyModel } from "@performyard/models";
import { AvatarProfile, Text, TextDate } from "@performyard/py-components";

import Link from "../../../../../components/Link";

import { appendCurrentLocationAsFrom } from "../../../../../utils/surveysBreadcrumbs";

export const getDateCell = (date: Date | null) => {
	if (!date || !isValid(date)) {
		return null;
	}
	return (
		<TextDate
			date={date}
			dateSize={"large"}
			size={"paragraph-3"}
			weight={"regular"}
			overrideElement="span"
			hasTime={false}
		></TextDate>
	);
};

export const getSurveyNameCell = (survey: TSurveyModel, source?: string) => {
	const { name, status } = survey;
	const tab = status === "draft" ? "build" : "results";
	const baseHref = appendCurrentLocationAsFrom(`/surveys/${survey._id}?tab=${tab}`);
	const href = source ? `${baseHref}&source=${source}` : baseHref;
	return (
		<Link testId="survey-link" href={href}>
			<Text size="paragraph-3" weight="regular" dangerouslySetClassName="py-line-clamp-1">
				{name}
			</Text>
		</Link>
	);
};

export const getEmployeeNameCell = (employee: { _id: string; name: string } | null) => {
	if (!employee) {
		return null;
	}

	return <AvatarProfile employeeId={employee._id} employeeName={employee.name} />;
};
